/**
 * Health reports — list of agent-authored summaries.
 */

import { useHealthReports } from '../../api/health';
import styles from './health.module.css';

export function HealthReportsScreen() {
  const reports = useHealthReports();

  return (
    <div className={styles.page}>
      <header className={styles.head}>
        <div>
          <h2 className={styles.title}>Reports</h2>
          <div className={styles.subtitle}>
            Agent-authored summaries (weekly, monthly, ad-hoc). Reports show
            up here once an agent posts to{' '}
            <code>/api/apps/health/reports</code>.
          </div>
        </div>
      </header>

      {reports.isLoading ? (
        <div className={styles.muted}>Loading…</div>
      ) : (reports.data?.reports ?? []).length === 0 ? (
        <div className={styles.empty}>No reports yet.</div>
      ) : (
        <div className={styles.list}>
          {(reports.data?.reports ?? []).map((r) => (
            <div key={r.id} className={styles.row} style={{ display: 'block' }}>
              <div className={styles.rowTitle}>{r.title}</div>
              <div className={styles.rowMeta} style={{ marginTop: 4 }}>
                {r.type} · {r.periodStart ?? '—'} → {r.periodEnd ?? '—'}
              </div>
              {r.highlights.length > 0 && (
                <ul style={{ margin: '8px 0 0 18px', padding: 0, fontSize: 13, color: 'var(--ink-3)' }}>
                  {r.highlights.slice(0, 6).map((h, i) => (
                    <li key={i}>{h}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
